<template>
  <div class="language-switcher inline-flex relative">
    <div
      class="rounded-md flex px-3 w-32 py-1 md:py-2 border-2 items-center bg-white select-none cursor-pointer hover:border-awro-600"
      @click="isOpen = true"
      ref="button"
      style="-webkit-tap-highlight-color: transparent"
    >
      <div class="language-detail flex items-center flex-1">
        <span class="flag"><img :src="currentLocaleFlag" alt="" role="presentation"></span>
        <span class="name mx-1">{{ currentLocaleName }}</span>
      </div>
      <div class="icon">
        <svg
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.2 0.75713C8.39257 0.612701 8.63078 0.542582 8.87089 0.559646C9.111 0.57671 9.3369 0.679811 9.50711 0.850023C9.67732 1.02023 9.78042 1.24613 9.79749 1.48624C9.81455 1.72635 9.74443 1.96456 9.6 2.15713L5.6 6.15713C5.41307 6.34036 5.16175 6.44299 4.9 6.44299C4.63825 6.44299 4.38693 6.34036 4.2 6.15713L0.200002 2.15713C0.0555725 1.96456 -0.014547 1.72635 0.00251711 1.48624C0.0195812 1.24613 0.122683 1.02023 0.292895 0.850023C0.463106 0.679811 0.689003 0.57671 0.929112 0.559646C1.16922 0.542582 1.40743 0.612701 1.6 0.75713L4.9 4.04713L8.2 0.74713V0.75713Z"
            fill="#A0AEC0"
          />
        </svg>
      </div>
    </div>
    <div
          class="absolute rounded-md border-2 border-awro-600 w-full bg-white top-0 left-0 pb-2 block shadow-lg"
          v-if="isOpen"
          v-closable="{
              exclude: ['button'],
              handler: 'onClose'
            }"
    >
        <div
            class="py-2 flex items-center px-3 transition transition-colors duration-200 select-none hover:text-awro-600 hover:bg-gray-100 cursor-pointer"
            v-for="(lang, index) in locales"
            v-bind:key="index"
            @click="changeLocale(lang)"
        >
            <span><img :src="lang.flag" alt="" role="presentation"></span>
            <span class="flex-1 mx-1">{{lang.label}}</span>
            <div class="icon">
        <svg
          v-if="index==0"
          class="transform -rotate-180"
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.2 0.75713C8.39257 0.612701 8.63078 0.542582 8.87089 0.559646C9.111 0.57671 9.3369 0.679811 9.50711 0.850023C9.67732 1.02023 9.78042 1.24613 9.79749 1.48624C9.81455 1.72635 9.74443 1.96456 9.6 2.15713L5.6 6.15713C5.41307 6.34036 5.16175 6.44299 4.9 6.44299C4.63825 6.44299 4.38693 6.34036 4.2 6.15713L0.200002 2.15713C0.0555725 1.96456 -0.014547 1.72635 0.00251711 1.48624C0.0195812 1.24613 0.122683 1.02023 0.292895 0.850023C0.463106 0.679811 0.689003 0.57671 0.929112 0.559646C1.16922 0.542582 1.40743 0.612701 1.6 0.75713L4.9 4.04713L8.2 0.74713V0.75713Z"
            fill="#A0AEC0"
          />
        </svg>
      </div>

        </div>
    </div>
  </div>
</template>

<script>
import en from "@/assets/flags/en.jpg";
import ku from "@/assets/flags/ku.jpg";
import ar from "@/assets/flags/ar.jpg";
import {mapGetters} from 'vuex';

export default {
  name: "LanguageSwitcher",
  data() {
    return {
      selected: 'ku',
      isOpen: false,
      locales: [
        {
          code: "en",
          label: "English",
          flag: en,
          apiLocale: 'en'
        },
        {
          code: "ku",
          label: "کوردی",
          flag: ku,
          apiLocale: 'ku-Arab'
        },
        {
          code: "ar",
          label: "العربية",
          flag: ar,
          apiLocale: 'ar-SA'
        }
      ]
    };
  },
  computed: {
    currentLocale() {
      return this.locales.filter(
        function(locale) {
          return locale.code == this.selected;
        }.bind(this)
      )[0];
    },
    currentLocaleName() {
      return this.currentLocale.label;
    },
    currentLocaleFlag() {
      return this.currentLocale.flag;
    },
    ...mapGetters({
      isRtl: ['locale/IS_RTL'],
      locale: ['locale/CURRENT_LOCALE']
    })
  },
  created() {
    this.selected  = this.locale
  },
  watch: {
    '$i18n.locale': function (locale) {
     this.selected  = locale
    }
  },
  methods: {
    changeLocale(locale) {
      this.selected = locale.code;
      this.isOpen = false;
      this.$store.dispatch("locale/SET_LANGUAGE", locale.code);
      this.$store.dispatch("locale/SET_API_LOCALE", locale.apiLocale);
    },
    onClose() {
      this.isOpen = false;
    }
  }
};
</script>

<style>
</style>
